<template>
    <footer class="footer navcentre"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <nav class="col-12">
                  <ul>
                      <li>
                          <a href="https://www.oel-schmidt.de/" class="navfooter navcentre">
                              Mineralölhandel Hans Schmidt GmbH & Co. KG
                          </a>
                      </li>
                  </ul>
              </nav>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="bottom_line">
              <div class="copyr">
                &copy; {{year}}, 
                <a href="https://www.minorec.cz/">
                        MINOREC k. s.
                </a>
              </div>
            </div>
          </div>
        </div>

    </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>

<style scoped>
.footer {
  background-color: lightgray !important;
  padding: 0.1rem 0.1rem;
}
.bottom_line {
  background-color: black !important;
  padding: 0.1rem 0.1rem !important;
  height: 50px !important;
  float: centre !important;
}
.copyr, .footer, .footer:not(.footer-big) {
  float: centre !important;
  color: white !important;
  padding-top: 10px !important;;
  font-size: 12px !important;
}
.navfooter {
  color: black !important;
  padding-top: 10px !important;;
  font-size: 12px !important;
  font-weight: 700 !important;
}
.navcentre {
  float: centre !important;
}
</style>

